import { render, staticRenderFns } from "./Article_releasesedit.vue?vue&type=template&id=7438ad98&style=true"
import script from "./Article_releasesedit.vue?vue&type=script&lang=js"
export * from "./Article_releasesedit.vue?vue&type=script&lang=js"
import style0 from "./Article_releasesedit.vue?vue&type=style&index=0&id=7438ad98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports